import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 19,
	viewBox: "0 0 13 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.5 0.214233C2.90643 0.214233 0 3.12066 0 6.71423C0 11.5892 6.5 18.7857 6.5 18.7857C6.5 18.7857 13 11.5892 13 6.71423C13 3.12066 10.0936 0.214233 6.5 0.214233ZM6.5 9.03566C5.21857 9.03566 4.17857 7.99566 4.17857 6.71423C4.17857 5.43281 5.21857 4.39281 6.5 4.39281C7.78143 4.39281 8.82143 5.43281 8.82143 6.71423C8.82143 7.99566 7.78143 9.03566 6.5 9.03566Z",
		fill: "currentColor"
	})
});
export default SvgLocationIcon;
